_options$series